import { questionApi } from "../../api/questionApi";
import { actionsDefinition } from '../actionsDefinition';
import { httpCallStartAction } from "../../middlewares/http/actions";
import { loadQuestionsAction } from "./loadQuestions";
import { loadQuestionCategoriesAction } from "./loadQuestionCategories";
import * as toastr from 'toastr';

export const deleteQuestionAction = (questionId: string, successMessage: string) => (dispatch: any) => {
    dispatch(httpCallStartAction());
    questionApi.DeleteQuestionAsync(questionId).then((result) => {
        dispatch(loadQuestionsAction());
        dispatch(loadQuestionCategoriesAction());
        dispatch(deleteQuestionCompleted(result));
        toastr.success(successMessage, '', { timeOut: 3000 });
    }).catch(error => {
        toastr.error(error);
    });

    const deleteQuestionCompleted = (result: boolean) => ({
        type: actionsDefinition.DELETE_QUESTION,
        payload: result,
        meta: {
            httpEnd: true
        }
    });
}